export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getItem: state => id => state.items.find(item => item.id == id),
  },
  actions: {

    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'popup',
        namespace: 'popup',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'popup',
        namespace: 'popup',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/popup.js